import React, { useCallback, useEffect } from 'react';
import { DisplayEmail, SendEmailDescription, CloseModalLink, Container, PopupError, PopupHeader, ActionButton, ContentContainer, FooterBanner, MFALink } from "../styles";
import { texts } from "../../config/texts";
import SendEmailIcon from "../../icons/SendEmailIcon";
import { clickstreamViewEvent, interactionRioEvent } from "../../lib/rio";
import { Step } from "../MfaByEmail/MfaByEmail.types";
import getProviderIcon from "../getProviderIcon";
import { NotificationTypes } from '@chegg-ui/notification-banner';
var SendEmail = function SendEmail(props) {
  var email = props.email,
    authProvider = props.authProvider,
    onModalClose = props.onModalClose,
    sendCodeToEmail = props.sendCodeToEmail,
    errorMessage = props.errorMessage,
    isLoading = props.isLoading;
  var sendEmailText = texts.sendEmailText,
    errorMessages = texts.errorMessages;
  useEffect(function () {
    var provider = authProvider ? authProvider : '';
    clickstreamViewEvent(Step.SendEmail, provider);
  }, [authProvider]);
  var handleClick = useCallback(function () {
    interactionRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'button',
          name: 'send code',
          region_name: 'mfa send code modal',
          text: texts.sendEmailText.buttonText
        }
      }
    });
    sendCodeToEmail(email);
  }, [sendCodeToEmail, email]);
  var closeModal = useCallback(function () {
    onModalClose();
  }, [onModalClose]);
  var renderCloseModalLink = function renderCloseModalLink(error) {
    if (error === errorMessages.expired_token) {
      return /*#__PURE__*/React.createElement(CloseModalLink, {
        "data-test": "mfa_return_to_signin_link",
        onClick: closeModal
      }, errorMessages.start_over_link_text);
    }
  };
  var onContactUsClick = function onContactUsClick() {
    interactionRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'link',
          name: 'reach out for help',
          region_name: 'mfa send code modal faq link',
          text: sendEmailText.footerFAQ
        }
      }
    });
  };
  return /*#__PURE__*/React.createElement(Container, {
    id: 'sendEmailDialog',
    "data-test": "send_email_dialog"
  }, /*#__PURE__*/React.createElement(SendEmailIcon, null), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(PopupHeader, {
    "data-test": "send_email_header"
  }, sendEmailText.header), /*#__PURE__*/React.createElement(SendEmailDescription, null, sendEmailText.description), /*#__PURE__*/React.createElement(DisplayEmail, {
    id: 'displayEmail',
    "data-test": 'display_email'
  }, authProvider && getProviderIcon(authProvider), /*#__PURE__*/React.createElement("span", null, email))), /*#__PURE__*/React.createElement(ActionButton, {
    type: "submit",
    size: "large",
    "data-test": "send_email_button",
    isLoading: isLoading,
    onClick: handleClick
  }, sendEmailText.buttonText), errorMessage && /*#__PURE__*/React.createElement(PopupError, {
    "data-test": "send_email_error"
  }, errorMessage, renderCloseModalLink(errorMessage)), /*#__PURE__*/React.createElement(FooterBanner, {
    "data-test": "send_email_footer_banner",
    id: "sendEmailFooterContent",
    type: NotificationTypes.Information,
    message: sendEmailText.footer,
    bannerStyle: "inline",
    ctaLink: /*#__PURE__*/React.createElement(MFALink, {
      "data-test": "contact_us_link",
      target: "_blank",
      href: 'https://www.chegg.com/contactus?a=How-does-multi-factor-authentication-work---id--HhfxSshaSpKIqQW-Er4qfA',
      onClick: onContactUsClick
    }, sendEmailText.footerFAQ),
    title: sendEmailText.footerTitle,
    fluid: true
  }));
};
export default SendEmail;